import { useDispatch, useSelector } from "react-redux";
import Popup from "../../../components/Popup";

import style from "../../../sass/components/popups/create-shipment-popup.module.scss";
import {
    closeCreatePopup,
    createPopupChangingDataClear,
    createShipment,
    selectCreatePopup,
    selectShipmentCreatingError,
    selectShipmentCreatingStatus,
} from "../shipmentsSlice";
import Receiver from "./Receiver";
import { validateBlock } from "./helper";
import AdditionalData from "./AdditionalData";
import { useEffect, useState } from "react";
import { pushAlert } from "../../alerts/alertSlice";
import { deliveryTypes } from "../../../data/static-data";
import { useTranslation } from "react-i18next";

const initialState = {
    "sender-city-code": "",
    "sender-town-id": "",
    "sender-district-id": "",
    "sender-address": "",
    "receiver-company": "",
    "receiver-postal-index": "",
    "receiver-name": "",
    "receiver-address": "",
    "receiver-phone-number": "",
    "receiver-email": "",
    "receiver-country": "Россия",
    "receiver-city": "",
    "receiver-area": "",
    "receiver-district": "",
    "receiver-description": "",
    "package-type": "",
    "delivery-type": "",
    "delivery-speed": "",
    "payment-type": "",
    "getting-package-type": deliveryTypes[1].value,
    "declared-price": "",
    "declared-price-currency": "TRY",
    "B2B-order-type": "courier",
    "B2B-order-number": "",
    countryHasCities: true,
};

const initialErrorsState = {
    "sender-city": "",
    "receiver-company": "",
    "receiver-name": "",
    "receiver-address": "",
    "receiver-phone-number": "",
    "receiver-email": "",
    "receiver-country": "",
    "receiver-city": "",
    "receiver-area": "",
    "receiver-district": "",
    "receiver-description": "",
    "delivery-type": "",
    "delivery-speed": "",
    "package-type": "",
    "payment-type": "",
};

const ShipmentPopup = () => {
    const {t} = useTranslation()
    const dispatch = useDispatch();
    
    const creatingStatus = useSelector(selectShipmentCreatingStatus);
    const creatingError = useSelector(selectShipmentCreatingError);

    const popupState = useSelector(selectCreatePopup);
    const closePopup = () => {
        setCurrentPage(1)
        dispatch(closeCreatePopup());
    };

    let maxPage = 2;
    const [currentPage, setCurrentPage] = useState(1);
    const [state, setState] = useState(initialState);
    const [errors, setErrors] = useState(initialErrorsState);

    const handlePrevButtonClick = () => {
        if (currentPage <= 1) {
            return;
        }
        setCurrentPage((prev) => prev - 1);
    };
    const handleNextButtonClick = () => {
        const [isBlockValid, validationErrors] = validateBlock(
            currentPage,
            state,
        );

        if (!isBlockValid) {
            validationErrors.forEach(error => {
                dispatch(pushAlert({
                    type: 'danger',
                    message: error,
                    delay: 2000,
                }))
            })
            return;
        }
        setCurrentPage((prev) => prev + 1);
    };
    const handleCreateButtonClick = () => {
        if (currentPage !== maxPage) {
            return;
        }

        const [isBlockValid, validationErrors] = validateBlock(
            currentPage,
            state,
        );

        if (!isBlockValid) {
            validationErrors.forEach(error => {
                dispatch(pushAlert({
                    type: 'danger',
                    message: t(error),
                    delay: 2000,
                }))
            })
            return;
        }
        dispatch(createShipment({ data: state }));
    };

    useEffect(() => {
        if (creatingStatus !== "fulfilled") {
            return
        }
        
        dispatch(closeCreatePopup());
        setCurrentPage(1);
        setState(initialState);
        setErrors(initialErrorsState);
    }, [dispatch, creatingStatus]);

    //TODO: handle creating error
    useEffect(() => {
        if(creatingError) {
            dispatch(pushAlert({
                type: 'danger',
                message: t(creatingError),
                delay: 2000,
            }))
        }
    }, [dispatch, creatingError])

    return (
        <Popup opened={popupState.opened} closeCallback={closePopup}>
            <form id="create-shipment-form" action="">
                    <div className={currentPage !== 1 ? "hidden" : ""}>
                        <AdditionalData
                            state={state}
                            setState={setState}
                            errors={errors}
                            setErrors={setErrors}
                        />
                    </div>
                    <div className={currentPage !== 2 ? "hidden" : ""}>
                        <Receiver
                            state={state}
                            setState={setState}
                            errors={errors}
                            setErrors={setErrors}
                            ownPage={false}
                            currentPage={currentPage}
                        />
                    </div>
            </form>

            <footer className="flex gap-2 mt-2 p-2">
                <button
                    className={`${style.btn} ${style["btn-red"]}`}
                    onClick={handlePrevButtonClick}
                    disabled={currentPage <= 1}
                >
                    {t("shipments.create_shipment.back")}{" "}
                </button>

                <button
                    onClick={handleNextButtonClick}
                    className={`${style.btn} ${style["btn-primary"]} ${
                        currentPage >= maxPage ? "hidden" : ""
                    }`}
                >
                {t("shipments.create_shipment.next")}{" "}
                </button>

                <button
                    onClick={handleCreateButtonClick}
                    className={`${style.btn} ${style["btn-primary"]} ${
                        currentPage !== maxPage ? "hidden" : ""
                    }`}
                >
                {t("shipments.create_shipment.create")}{" "}
                </button>
            </footer>
            {creatingStatus === "pending" && <div>Loading...</div>}
        </Popup>
    );
};

export default ShipmentPopup;
